import type { AccountConfiguration } from "@/types/account";

export const accountConfigurationQueryFn = async <
  T = AccountConfiguration | Record<string, AccountConfiguration>,
>(
  allPlans?: boolean
) => {
  const { data } = await useGetRequest<T>("/account/configuration-settings", {
    params: {
      ...(allPlans ? { allPlans } : {}),
    },
  });
  return data || null;
};

// current plan
export function useAccountFeatureConfigurationRequest() {
  const { setCachedData, maybeGetFromCacheAndRefetch } = useApiCache();
  const enabled = computed(() => !!currentSessionInformation.appAuthToken);
  const request = useQuery({
    queryKey: ["configuration"],
    queryFn: async () => {
      const { cachedData, isInitialized } = maybeGetFromCacheAndRefetch(
        "accountConfiguration",
        ["configuration"]
      );
      if (cachedData && !isInitialized) return cachedData;
      const data = await accountConfigurationQueryFn<AccountConfiguration>();
      if (data) setCachedData("accountConfiguration", data);
      return data;
    },
    staleTime: 5 * MINUTE,
    enabled,
  });
  return request;
}

// All plans
export function useAllAccountFeatureConfigurationRequest() {
  const enabled = computed(() => !!currentSessionInformation.appAuthToken);
  const request = useQuery({
    queryKey: ["configuration", true],
    queryFn: () =>
      accountConfigurationQueryFn<Record<string, AccountConfiguration>>(true),
    staleTime: 5 * MINUTE,
    enabled,
  });
  return request;
}
